import { render, staticRenderFns } from "./EmploymentTypeDetail.vue?vue&type=template&id=4af68ecf&"
import script from "./EmploymentTypeDetail.vue?vue&type=script&lang=js&"
export * from "./EmploymentTypeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports